/**
 * Hide the bound element on non-development targets
 * Usage: <element v-test-only />
 */

import type { Directive } from "vue";

const nonTestSubdomains = ["beta-abc", "abc"];

export const testOnly: Directive<HTMLElement> = {
  created: (el) => {
    const subdomain = window.location.hostname.split(".")[0];

    if (nonTestSubdomains.includes(subdomain)) {
      el.style.display = "none";
    }
  }
};
